<template>
  <div>
    <b-row>
      <b-col cols="6">{{ titleLabelUnitPrice }}</b-col>
      <b-col cols="6">{{ titleLabelTotalPrice }}</b-col>
    </b-row>
    <b-row class="supplierRow mb-3">
      <b-col cols="6">
        <div>
          <span class="smallText">{{ $t('general.netPrice') }}: </span>
          <span class="currency">{{ getNetPrice(unitPrice) }} {{ currency }}</span>

          <span class="smallText">{{ $t('general.grossPrice') }}: </span>
          <span class="currency">{{ Number(unitPrice).toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) }} {{ currency }}</span>
        </div>
      </b-col>

      <b-col cols="6">
        <div>
          <span class="smallText">{{ $t('general.netPrice') }}: </span>
          <span class="currency">{{ getNetPrice(totalPrice) }} {{ currency }}</span>

          <span class="smallText">{{ $t('general.grossPrice') }}: </span>
          <span class="currency">{{ Number(totalPrice).toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) }} {{ currency }}</span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { getNetPrice } from '@/utils/functions'

export default {
  name: 'SheetRowSellingPrices',
  props: {
    unitPrice: [String, Number],
    totalPrice: [String, Number],
    isGlassPrice: Boolean,
    currency: String
  },
  computed: {
    titleLabelUnitPrice() {
      const glassPriceLabel = `${this.$t('detailPanel.vkGlasses')} ${this.$t('receiptMatcher.unitPrice')}`
      const bottlePriceLabel = `${this.$t('general.vk_short')} ${this.$t('receiptMatcher.unitPrice')}`

      return this.isGlassPrice ? glassPriceLabel : bottlePriceLabel
    },
    titleLabelTotalPrice() {
      const glassPriceTotalLabel = `${this.$t('detailPanel.vkGlasses')} ${this.$t('receiptMatcher.totalPrice')}`
      const bottlePriceTotalLabel = `${this.$t('general.vk_short')} ${this.$t('receiptMatcher.totalPrice')}`

      return this.isGlassPrice ? glassPriceTotalLabel : bottlePriceTotalLabel
    },
  },
  methods: {
    getNetPrice,
  }
}

</script>